
export interface RouteConfig {
  LABEL: string;
  HREF: string;
}

export interface RouteConfigWithTranslation {
  LABEL: (t: Function) => string;
  HREF: (t: Function) => string;
}

export const RoutesEnum = {
  LOGIN: {
    LABEL: (t: Function) => t('routes_login_label'),
    HREF: (t: Function) => t('routes_login_href')
  },
  
  HOME: {
    LABEL: (t: Function) => t('routes_home_label'),
    HREF: (t: Function) => t('routes_home_href')
  },
  
  DASHBOARD: {
    LABEL: (t: Function) => t('routes_dashboard_label'),
    HREF: (t: Function) => t('routes_dashboard_href')
  },
  
  FEATURES: {
    LABEL: (t: Function) => t('routes_features_label'),
    HREF: (t: Function) => t('routes_features_href')
  },
  
  NOTIFICATIONS: {
    LABEL: (t: Function) => t('routes_notifications_label'),
    HREF: (t: Function) => t('routes_notifications_href')
  },
  
  
  RESET_PASSWORD: {
    LABEL: (t: Function) => t('routes_reset_password_label'),
    HREF: (t: Function) => t('routes_reset_password_href')
  },
  
  USER_MANAGEMENT: {
    LABEL: (t: Function) => t('routes_user_management_label'),
    HREF: (t: Function) => t('routes_user_management_href')
  },
  
  CUSTOMER_MANAGEMENT: {
    LABEL: (t: Function) => t('routes_customer_management_label'),
    HREF: (t: Function) => t('routes_customer_management_href')
  },
  
  CONTACT_MANAGER: {
    LABEL: (t: Function) => t('routes_contact_manager_label'),
    HREF: (t: Function) => t('routes_contact_manager_href')
  },
  
  ACCOUNT_SETTINGS: {
    LABEL: (t: Function) => t('routes_account_settings_label'),
    HREF: (t: Function) => t('routes_account_settings_href')
  },
  
  SUBSCRIPTION_PLAN: {
    LABEL: (t: Function) => t('routes_subscription_plan_label'),
    HREF: (t: Function) => t('routes_subscription_plan_href')
  },
  
  NOTIFICATION_HISTORY: {
    LABEL: (t: Function) => t('routes_notification_history_label'),
    HREF: (t: Function) => t('routes_notification_history_href')
  },

  DASHBOARDS: {
    LABEL: (t: Function) => t('routes_dashboards_label'),
    HREF: (t: Function) => t('routes_dashboards_href')
  },

  CREATE_ACCOUNT: {
    LABEL: (t: Function) => t('routes_create_account_label'),
    HREF: (t: Function) => t('routes_create_account_href')
  },

  TOKEN_CONFIRMATION: {
    LABEL: (t: Function) => t('routes_token_confirmation_label'),
    HREF: (t: Function) => t('routes_token_confirmation_href')
  },

  PLAN_SELECTION: {
    LABEL: (t: Function) => t('routes_plan_selection_label'),
    HREF: (t: Function) => t('routes_plan_selection_href')
  },

  WARNING_EMAIL_BLAST: {
    LABEL: (t: Function) => t('routes_warning_email_blast_label'),
    HREF: (t: Function) => t('routes_warning_email_blast_href')
  }
} as const;

// Static routes for cases where translation is not available
export const StaticRoutes = {
  LOGIN: {
    LABEL: 'Login',
    HREF: '/login'
  },
  
  HOME: {
    LABEL: 'Home',
    HREF: '/'
  },
  
  DASHBOARD: {
    LABEL: 'Dashboard',
    HREF: '/imigra-pulse-canada/dashboard'
  },
  
  FEATURES: {
    LABEL: 'Features',
    HREF: '/imigra-pulse-canada/features'
  },
  
  NOTIFICATIONS: {
    LABEL: 'Notifications',
    HREF: '/imigra-pulse-canada/notifications'
  },
  
  
  RESET_PASSWORD: {
    LABEL: 'Reset Password',
    HREF: '/reset-password'
  },
  
  USER_MANAGEMENT: {
    LABEL: 'User Management',
    HREF: '/imigra-pulse-canada/user-management'
  },
  
  CUSTOMER_MANAGEMENT: {
    LABEL: 'Customer Management',
    HREF: '/imigra-pulse-canada/customer-management'
  },
  
  CONTACT_MANAGER: {
    LABEL: 'Contact Manager',
    HREF: '/contact-manager'
  },
  
  ACCOUNT_SETTINGS: {
    LABEL: 'Account Settings',
    HREF: '/account-settings'
  },
  
  SUBSCRIPTION: {
    LABEL: 'Subscription / Plan',
    HREF: '/subscription-plan'
  },
  
  NOTIFICATION_HISTORY: {
    LABEL: 'Notification History',
    HREF: '/imigra-pulse-canada/notification-history'
  },

  DASHBOARDS: {
    LABEL: 'Dashboards',
    HREF: '/imigra-pulse-canada/dashboards'
  },

  CREATE_ACCOUNT: {
    LABEL: 'Create Account',
    HREF: '/create-account'
  },

  TOKEN_CONFIRMATION: {
    LABEL: 'Token Confirmation',
    HREF: '/token-confirmation'
  },

  PLAN_SELECTION: {
    LABEL: 'Plans',
    HREF: '/plans'
  },

  WARNING_EMAIL_BLAST: {
    LABEL: 'Notice Blasts',
    HREF: '/imigra-pulse-canada/warning-email-blast'
  }
} as const;
